export const detectPfWithdrawalIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete withdrawal request" || cleaned === "remove withdrawal request") {
        return { intent: "delete_withdrawal_request" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) withdrawal request/);
    if (deleteMatch) {
        return { intent: "delete_withdrawal_request", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create withdrawal request") || cleaned.includes("add withdrawal request")) {
        return { intent: "create_withdrawal_request" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create withdrawal request named (.+)/);
    if (createMatch) {
        return { intent: "create_withdrawal_request", name: createMatch[1].trim() };
    }

    return null;
};
